
import { Component, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { UserMe } from '@serasa/core/modules/recertification/interfaces/user-me.interface';
import { loadResetUser } from '@serasa/core/modules/users/state/actions/user.actions';
import { selectUserMeInfo } from '@serasa/core/modules/users/state/selectors/user.selectors';
import { SharedModule } from '@serasa/shared/shared.module';
import { Utils } from '@serasa/shared/utils/utils';
import { HeaderUserData, SedsHeaderModule } from "@serasa/shared/seds";
import { Observable } from 'rxjs';
import { VirtualTourService } from '../virtual-tour/services/virtual-tour.service';
import { SubMenuComponent } from './components/sub-menu/sub-menu.component';

interface MenuButtonEvent {
  id: number;
  buttonLabel?: string;
  buttonIconLabel?: string;
  iconCustomClass?: string;
  callbackButtonItemClick?: boolean;
}

@Component({
    imports: [
        SharedModule,
        SedsHeaderModule,
        SubMenuComponent
    ],
    selector: 'pl-header',
    styleUrls: ['./header.component.scss'],
    templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  public userData$?: Observable<UserMe | null | undefined>;
  public userData: HeaderUserData = {};

  constructor(
    private readonly store: Store,
    private readonly _virtualTourService: VirtualTourService
  ) { }

  ngOnInit(): void {
    this.userData$ = this.store.select(selectUserMeInfo);
    this.userData$?.subscribe((user) => {
      this.userData = {
        name: user?.fullName || '',
        email: user?.email || '',
        showAvatar: true,
        avatarImage: '',
        menuButtonList: [
          [
            {
              id: 1,
              buttonLabel: 'Tour Virtual',
              buttonIconLabel: '360',
              iconCustomClass: 'security',
              callbackButtonItemClick: true,
            },
            {
              id: 2,
              buttonLabel: 'Sair',
              buttonIconLabel: 'logout',
              iconCustomClass: 'security',
              callbackButtonItemClick: true,
            },
          ],
        ],
      };
    });
  }

  backTo(): void {
    const url = Utils.getOriginUrl();
    const buttonClick = document.createElement('a');
    buttonClick.href = url;
    buttonClick.click();
  }

  buttonItemClick(pageEvent: MenuButtonEvent): void {
    if (pageEvent.id === 1) {
      this.startTour();
    } else if (pageEvent.id === 2) {
      this.logout();
    }
  }

  public logout(): void {
    Utils.deleteCookie('accessToken');
    localStorage.removeItem('isPME');
    this.store.dispatch(loadResetUser());
    Utils.redirectToLogin();
  }

  public startTour() {
    this._virtualTourService.isOnTour.next(true);
  }
}
